import { render, staticRenderFns } from "./OrganizationReference.vue?vue&type=template&id=482d3aa8"
import script from "./OrganizationReference.vue?vue&type=script&lang=ts"
export * from "./OrganizationReference.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports